import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TicketService {

  constructor(
    private http: CustomHttpService
  ) { }

  getAllTickets(body: any): Observable<any> {
    return this.http.post(environment.getAllTickets, body);
  }

  createTicket(body: any): Observable<any> {
    return this.http.post(environment.createTicket, body);
  }

  updateTicket(body: any): Observable<any> {
    return this.http.post(environment.updateTicket, body);
  }

  deleteTicket(body: any): Observable<any> {
    return this.http.post(environment.deleteTicket, body);
  }

  updateMultipleTicket(body: any): Observable<any> {
    return this.http.post(environment.updateMultipleTicket, body);
  }

  getFilteredTickets(body: any): Observable<any> {
    return this.http.post(environment.getFilteredTickets, body);
  }

  addTicketComment(body: any): Observable<any> {
    return this.http.post(environment.addTicketComment, body);
  }

  getTicketActivities(body: any): Observable<any> {
    return this.http.post(environment.getTicketActivities, body);
  }

  updateTicketActivity(body: any): Observable<any> {
    return this.http.post(environment.updateTicketActivity, body);
  }

  deleteTicketActivity(body: any): Observable<any> {
    return this.http.post(environment.deleteTicketActivity, body);
  }
}
